
import React, {useState} from "react";
import "./Snapmint.css";
import snapmint from '../../images/project/snapmint-timeline.png';
import a from '../../images/casestudies/snapinv1.webp';
import b from '../../images/casestudies/snapinv2.webp';
import c from '../../images/casestudies/snapinv3.webp';
import d from '../../images/casestudies/snapinv4.webp';
import e from '../../images/casestudies/snapinv5.webp';
import f from '../../images/casestudies/snapinv6.webp';


const FlipCard = ({ frontText, backContent }) => {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <p className="text-white ">{frontText}</p>
        </div>
        <div className="flip-card-back">
          {backContent}
        </div>
      </div>
    </div>
  );
};
const SnapmintPage = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="container my-5">
      <div className="roundBorder">
      
      <h2 className="titleServ">
      Snapmint – One of the Leading Purchase Finance Co in India
              </h2>
              <div className="lineServ mt-40"></div>
      <div className=" mt-40">
                    <div >
                      <img className="snampmint-timeline-caseImg" src={snapmint} alt="" />
                    </div>
                  </div>

                  <div className="investors-section">
      <div
        className={`header ${isOpen ? "open" : "closed"}`}
        onClick={toggleSection}
      >
       <span className={isOpen ? "title-open" : "title-closed"}>
          INVESTORS
        </span>
        <button className={isOpen ? "title-open toggle-button" : "title-closed toggle-button"}>
          {isOpen ? "-" : "+"}
        </button>
      </div>
      {isOpen && (
        <div className="container">
  <div className="row justify-content-center">
    <div className="col-12 col-md-3 text-center">
      <a href="https://prudentim.com/">
        <img src={a} alt="Prudential" className="img-fluid" />
      </a>
    </div>
    <div className="col-12 col-md-3 text-center">
      <a href="https://kae-capital.com/">
        <img src={b} alt="Kae Capital" className="img-fluid" />
      </a>
    </div>
    <div className="col-12 col-md-3 text-center">
      <a href="#">
        <img src={c} alt="Radix Cap" className="img-fluid" />
      </a>
    </div>
    <div className="col-12 col-md-3 text-center">
      <a href="https://radixcap.in/">
        <img src={d} alt="Radix Cap" className="img-fluid" />
      </a>
    </div>
  </div>
</div>

          
        
      )}
    </div>
    <div className="card-container">
      <FlipCard
        frontText="End of 2019 - FinTech Market wave"
        backContent={
          <div className="flip-back-card">
            <img  src={e} alt="Affirm" />
            
            <ul>
              <li>Tech disruption in <strong>Personal Lending</strong> for Bharat.</li>
              <li><strong>Checkout finance</strong> - US model will be replicated in India.</li>
            </ul>
          </div>
        }
      />
      <FlipCard
        frontText="Radix Deep Dive"
        backContent={

          <ul className="back-2">
              <li> Personal Lending space is a <strong>Cost of Capital game</strong></li>
              <li>Fintech should play <strong>where OPEX disruption is the moat.</strong></li>
              <li> Financing<strong>specific purchases of healthy customers</strong> is the key through digital play.</li>
              <li><strong>Powering merchant will be the key</strong> and it has to be beyond Amazon & Flipkart.</li>
            </ul>
       
        }
      />
      
    </div>

       
    <h2 className="titleServ snap-title2">
    Snapmint – Emerging as India’s most successful BNPL player
              </h2>
              <div className="lineServ mt-40"></div>
      <div className="row my-4">
        <div className="col-md-6">
          <div className="">
            <img src={f} alt="Snapmint" />
            
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-box">
            <h4 className="titleServ titleServ2">Snapmint Today</h4>
            <div style={{"marginInlineStart":"160px"}} className="lineServ "></div>
            <p  className=" text-black fw-bold titleServ2">16x </p>
              <p className=" text-black">Growth in GTV</p>
            <p  className=" text-black fw-bold titleServ2">12x</p>
            <p className=" text-black"> Growth in customers</p>
            <p className=" text-black fw-bold titleServ2">A Minicorn!</p>
          </div>
        </div>
      </div>
      <div className="text-center my-5">
          <a href="/neewee">
            <button className="btnArrow">
              <i className="fa-solid fa-arrow-left"></i> Neewee
            </button>
          </a>
          &nbsp;&nbsp;
          <a href="/sukhhi">
            <button className="btnArrow">
              Sukhhi <i className="fa-solid fa-arrow-right"></i>
            </button>
          </a>
        </div>
        </div>
    </div>
  );
};

export default SnapmintPage;

